export default {
    
    cup_1:`<?xml version="1.0" encoding="utf-8"?>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 4000 4000" style="enable-background:new 0 0 4000 4000;" xml:space="preserve">
    <style type="text/css">
        .st0{fill:#F9C710;}
        .st1{fill:#F89F1D;}
        .st2{opacity:0.55;}
        .st3{fill:#FFFFFF;}
        .st4{fill:#6B184E;}
        .st5{opacity:0.42;}
    </style>
    <g>
        <g>
            <g>
                <path class="st0" d="M3275.28,1501.3l-21.49,2.42c-148.13,17.85-239.06,50.84-288.69,108.49c24.97,21.03,42.67,50.99,47.66,85.94
                    c2.12,15.28,1.82,30.41-0.91,44.64c0,0,0,0,0,0.15c-10.44,57.19-56.29,103.49-116.66,112.27
                    c-75.96,10.89-146.16-41.61-157.21-117.57c-2.72-19.97-1.36-39.34,3.93-57.5h-0.15c26.93-154.94,120.74-241.03,224.84-290.21
                    h0.15c98.5-46.6,206.23-60.07,275.23-67.63c1.51,0,2.88-0.3,4.09-0.45l4.54-0.45c143.89-21.33,243.91-155.54,223.18-299.59
                    c-20.73-144.65-155.24-245.27-299.74-224.39c-7.26,1.06-14.53,2.27-21.64,3.93l0.3,1.51c0.45,3.33,0.61,6.51,0.91,9.83
                    c0,0,0,0,0,0.15c0,0,0,0.15,0,0.3c1.21,17.7-0.76,34.8-5.9,50.99c-15.43,49.33-57.8,87.91-112.57,95.78
                    c-75.8,10.89-146.01-41.61-156.91-117.57c-7.26-50.08,13.16-97.59,49.63-127.1v-0.15c17.1-14.22,35.25-27.08,54.32-38.43
                    l0.15-0.15c50.54-30.26,106.82-50.38,165.83-58.86c243.76-35.1,470.41,134.51,505.37,378.27
                    C3688.65,1239.54,3519.04,1466.19,3275.28,1501.3z"/>
            </g>
            <g>
                <path class="st1" d="M3340.64,1290.68c92.9-51.9,149.19-157.36,133.15-268.87C3455.33,893.5,3347.3,799.69,3222.17,795
                    c0-6.2-0.45-12.41-1.36-18.61l-0.3-1.51c7.11-1.66,14.37-2.87,21.64-3.93c144.5-20.88,279.01,79.74,299.74,224.39
                    C3561.55,1131.96,3472.58,1259.66,3340.64,1290.68z"/>
            </g>
            <g class="st2">
                <path class="st3" d="M3012.76,1698.15c9.68,67.63-31.02,130.73-93.51,151.46c25.72-29.35,39.04-69.3,32.99-111.06
                    c-1.76-12.35-5.11-24.07-9.81-35c-17.17-39.96-2.54-87.11,36.55-106.16c0.31-0.15,0.63-0.31,0.95-0.46
                    c-5.3,4.84-10.29,9.99-14.83,15.28C2990.07,1633.24,3007.77,1663.2,3012.76,1698.15z"/>
            </g>
            <g>
                <path class="st1" d="M3153.63,812.7c0,0-2.27,21.49-5.9,51.45c-15.43,49.33-57.8,87.91-112.57,95.78
                    c-75.8,10.89-146.01-41.61-156.91-117.57c-7.26-50.08,13.16-97.59,49.63-127.1v-0.15c17.1-14.22,35.25-27.08,54.32-38.43
                    C2882.79,802.11,3054.07,938.13,3153.63,812.7z"/>
            </g>
            <g>
                <path class="st1" d="M3011.85,1742.78c0,0,0,0,0,0.15c-10.44,57.19-56.29,103.49-116.66,112.27
                    c-75.96,10.89-146.16-41.61-157.21-117.57c-2.72-19.97-1.36-39.34,3.93-57.5h-0.15c26.93-154.94,120.74-241.03,224.84-290.21
                    h0.15C2809.86,1541.24,2840.88,1878.05,3011.85,1742.78z"/>
            </g>
            <g class="st2">
                <path class="st3" d="M3427.8,1450c120.59-95.47,188.68-250.72,165.23-413.67c-34.95-243.76-261.61-413.37-505.37-378.42
                    c-53.71,7.87-105.16,25.12-152.06,50.99c61.28-48.57,134.66-80.04,212.59-91.24c243.76-35.1,470.41,134.51,505.37,378.27
                    C3680.78,1184.46,3585.31,1362.7,3427.8,1450z"/>
            </g>
            <g>
                <path class="st4" d="M2875.28,1894.5c-86.33,0-162.02-63.58-174.67-151.47c-3.39-23.56-2.08-47,3.88-69.73
                    c58.92-336.69,403.56-374.38,533.33-388.58c0.7-0.08,1.42-0.14,2.13-0.18c0.46-0.06,1.6-0.24,2.06-0.28l4.52-0.5
                    c121.81-18.06,207.62-133.27,189.88-256.64c-17.23-119.83-125.77-204.55-244.86-193.75c-2.02,34.6-13.94,67.23-34.79,95.08
                    c-28.25,37.73-69.54,62.23-116.27,68.94c-46.68,6.71-93.13-5.14-130.85-33.41c-37.71-28.27-62.19-69.55-68.91-116.26
                    c-8.63-60.05,14.64-120.98,60.85-159.85c0.69-0.67,1.43-1.33,2.19-1.97c68.26-56.49,150.94-93.05,239.07-105.72
                    c127.81-18.38,255.33,14.19,358.96,91.77c103.63,77.57,170.83,190.71,189.22,318.57c38,264.24-146.07,510.16-410.33,548.17
                    l-22.55,2.62c-115.5,13.88-193.13,37.26-239.94,72.77c16.77,22.99,27.83,49.92,31.96,78.68
                    c13.86,96.37-53.27,186.05-149.65,199.91C2892.04,1893.91,2883.61,1894.5,2875.28,1894.5z M2779.52,1683.52
                    c-0.21,2.32-0.64,4.64-1.29,6.95c-3.85,13.52-4.77,27.57-2.73,41.78c7.92,55.08,59.17,93.39,114.26,85.55
                    c55.08-7.92,93.45-59.19,85.52-114.27c-3.51-24.45-15.78-46.59-34.54-62.33c-7.74-6.49-12.56-15.82-13.39-25.9
                    c-0.82-10.08,2.43-20.07,9.01-27.73c55.55-64.63,152.07-102.07,312.94-121.38l21.67-2.5c221.92-31.94,377.23-239.43,345.16-462.4
                    c-15.5-107.84-72.21-203.3-159.66-268.76c-87.45-65.44-195.01-92.92-302.86-77.45c-73.42,10.56-142.33,40.75-199.45,87.36
                    c-0.78,0.75-1.61,1.49-2.46,2.18c-27.69,22.39-41.18,56.91-36.08,92.36c3.84,26.72,17.82,50.32,39.38,66.48
                    c21.52,16.12,48.08,22.87,74.71,19.08c26.73-3.85,50.33-17.84,66.47-39.4c16.14-21.56,22.92-48.16,19.07-74.87
                    c-2.79-19.43,9.55-39.28,28.68-43.71c8.15-1.91,16.35-3.43,24.76-4.62c79.88-11.51,159.57,8.87,224.33,57.37
                    c64.78,48.49,106.78,119.2,118.27,199.09c23.64,164.47-90.79,318.07-255.11,342.41l-5.93,0.67c-0.93,0.16-2.84,0.4-5.09,0.56
                    C3051.52,1381.29,2824.23,1437.49,2779.52,1683.52z"/>
            </g>
        </g>
        <g>
            <g>
                <path class="st0" d="M723.81,1501.3l21.49,2.42c148.13,17.85,239.07,50.84,288.69,108.49c-24.96,21.03-42.67,50.99-47.66,85.94
                    c-2.12,15.28-1.82,30.41,0.91,44.64c0,0,0,0,0,0.15c10.44,57.19,56.29,103.49,116.66,112.27
                    c75.96,10.89,146.16-41.61,157.21-117.57c2.72-19.97,1.36-39.34-3.93-57.5h0.15c-26.93-154.94-120.74-241.03-224.84-290.21h-0.15
                    c-98.5-46.6-206.23-60.07-275.23-67.63c-1.51,0-2.87-0.3-4.09-0.45l-4.54-0.45c-143.89-21.33-243.91-155.54-223.18-299.59
                    c20.73-144.65,155.24-245.27,299.74-224.39c7.26,1.06,14.53,2.27,21.64,3.93l-0.3,1.51c-0.45,3.33-0.61,6.51-0.91,9.83
                    c0,0,0,0,0,0.15c0,0,0,0.15,0,0.3c-1.21,17.7,0.76,34.8,5.9,50.99c15.43,49.33,57.8,87.91,112.57,95.78
                    c75.8,10.89,146.01-41.61,156.91-117.57c7.26-50.08-13.16-97.59-49.63-127.1v-0.15c-17.1-14.22-35.25-27.08-54.32-38.43
                    l-0.15-0.15c-50.54-30.26-106.82-50.38-165.83-58.86c-243.76-35.1-470.41,134.51-505.37,378.27
                    C310.44,1239.54,480.05,1466.19,723.81,1501.3z"/>
            </g>
            <g>
                <path class="st1" d="M658.45,1290.68c-92.9-51.9-149.19-157.36-133.15-268.87C543.76,893.5,651.79,799.69,776.92,795
                    c0-6.2,0.45-12.41,1.36-18.61l0.3-1.51c-7.11-1.66-14.37-2.87-21.64-3.93c-144.5-20.88-279.01,79.74-299.74,224.39
                    C437.54,1131.96,526.51,1259.66,658.45,1290.68z"/>
            </g>
            <g class="st2">
                <path class="st3" d="M986.33,1698.15c-9.68,67.63,31.02,130.73,93.51,151.46c-25.72-29.35-39.04-69.3-32.98-111.06
                    c1.76-12.35,5.11-24.07,9.81-35c17.17-39.96,2.54-87.11-36.55-106.16c-0.32-0.15-0.63-0.31-0.95-0.46
                    c5.3,4.84,10.29,9.99,14.83,15.28C1009.03,1633.24,991.32,1663.2,986.33,1698.15z"/>
            </g>
            <g>
                <path class="st1" d="M845.46,812.7c0,0,2.27,21.49,5.9,51.45c15.43,49.33,57.8,87.91,112.57,95.78
                    c75.8,10.89,146.01-41.61,156.91-117.57c7.26-50.08-13.16-97.59-49.63-127.1v-0.15c-17.1-14.22-35.25-27.08-54.32-38.43
                    C1116.3,802.11,945.02,938.13,845.46,812.7z"/>
            </g>
            <g>
                <path class="st1" d="M987.24,1742.78c0,0,0,0,0,0.15c10.44,57.19,56.29,103.49,116.66,112.27
                    c75.96,10.89,146.16-41.61,157.21-117.57c2.72-19.97,1.36-39.34-3.93-57.5h0.15c-26.93-154.94-120.74-241.03-224.84-290.21h-0.15
                    C1189.23,1541.24,1158.21,1878.05,987.24,1742.78z"/>
            </g>
            <g class="st2">
                <path class="st3" d="M571.29,1450c-120.59-95.47-188.68-250.72-165.23-413.67c34.95-243.76,261.61-413.37,505.37-378.42
                    c53.71,7.87,105.16,25.12,152.06,50.99c-61.28-48.57-134.66-80.04-212.59-91.24c-243.76-35.1-470.41,134.51-505.37,378.27
                    C318.31,1184.46,413.78,1362.7,571.29,1450z"/>
            </g>
            <g>
                <path class="st4" d="M1123.81,1894.5c-8.34,0-16.76-0.6-25.24-1.83c-96.38-13.86-163.51-103.54-149.66-199.91
                    c4.14-28.76,15.19-55.7,31.97-78.68c-46.82-35.51-124.47-58.91-240.1-72.79l-21.34-2.46
                    c-265.31-38.15-449.39-284.07-411.38-548.31c18.39-127.85,85.59-240.99,189.22-318.57c103.62-77.57,231.11-110.15,358.97-91.77
                    c88.12,12.66,170.8,49.23,239.06,105.72c0.76,0.63,1.51,1.29,2.21,1.99c46.2,38.87,69.46,99.78,60.83,159.83
                    c-6.72,46.71-31.19,87.99-68.91,116.26c-37.72,28.27-84.18,40.16-130.86,33.41c-46.72-6.71-88.01-31.2-116.26-68.94
                    c-20.98-28.03-32.91-60.9-34.92-95.08c-119.39-10.9-227.53,73.98-244.74,193.75c-17.74,123.37,68.07,238.57,191.29,256.81
                    l3.11,0.32l-1.52,37.93l3.75-37.63c131.73,14.35,476.37,52.05,535.29,388.73c5.96,22.71,7.27,46.15,3.89,69.73
                    C1285.83,1830.92,1210.13,1894.5,1123.81,1894.5z M786.64,650.85c-87.57,0-172.51,28.15-244.03,81.68
                    c-87.45,65.46-144.16,160.92-159.66,268.76c-32.07,222.97,123.25,430.46,346.22,462.54l20.46,2.34
                    c161.04,19.33,257.55,56.77,313.1,121.4c6.58,7.66,9.84,17.65,9.01,27.73c-0.82,10.08-5.65,19.41-13.39,25.9
                    c-18.76,15.74-31.02,37.87-34.55,62.33c-7.92,55.08,30.45,106.35,85.53,114.27c55.2,7.8,106.33-30.47,114.27-85.53
                    c2.03-14.21,1.11-28.29-2.74-41.8c-0.67-2.32-1.09-4.66-1.3-7.03c-44.73-246-272.02-302.15-465.67-323.43
                    c-2.27-0.16-4.37-0.42-6.46-0.73l-3.14-0.32c-165.72-24.51-280.16-178.11-256.52-342.58c11.49-79.9,53.49-150.6,118.27-199.09
                    c64.76-48.47,144.47-68.92,224.34-57.37c8.41,1.19,16.6,2.72,24.75,4.62c19.17,4.45,31.74,22.85,28.88,42.34
                    c-4.05,28.09,2.73,54.69,18.87,76.24c16.14,21.56,39.74,35.55,66.46,39.4c26.73,3.83,53.21-2.96,74.72-19.08
                    c21.56-16.16,35.54-39.76,39.38-66.48c5.1-35.45-8.39-69.97-36.08-92.36c-0.86-0.71-1.69-1.43-2.48-2.2
                    c-57.12-46.59-126.02-76.78-199.42-87.34C825.82,652.25,806.17,650.85,786.64,650.85z"/>
            </g>
        </g>
        <g>
            <g>
                <path class="st0" d="M2967.67,516.29h-1898.9c-58.49,0-105.91-47.42-105.91-105.91l0,0c0-58.5,47.42-105.92,105.91-105.92h1898.9
                    c58.5,0,105.91,47.42,105.91,105.92l0,0C3073.59,468.87,3026.17,516.29,2967.67,516.29z"/>
            </g>
            <g class="st2">
                <rect x="1684.08" y="322.11" class="st3" width="542.18" height="194.18"/>
            </g>
            <g class="st2">
                <rect x="2293.11" y="322.11" class="st3" width="102.11" height="194.18"/>
            </g>
            <g>
                <path class="st1" d="M1300.72,516.29h-231.95c-58.56,0-105.91-47.36-105.91-105.91c0-29.35,11.8-55.68,31.02-74.9
                    c19.22-19.22,45.54-31.02,74.9-31.02h231.95c-29.2,0-55.68,11.8-74.9,31.02c-19.06,19.22-31.02,45.54-31.02,74.9
                    C1194.81,468.93,1242.32,516.29,1300.72,516.29z"/>
            </g>
            <g class="st2">
                <path class="st3" d="M3073.59,410.37c0,29.35-11.8,55.68-31.02,74.9c-19.22,19.22-45.54,31.02-74.9,31.02h-131.18
                    c29.2,0,55.83-11.8,74.9-31.02c19.22-19.22,31.02-45.54,31.02-74.9c0-58.56-47.36-105.92-105.92-105.92h131.18
                    C3026.23,304.46,3073.59,351.82,3073.59,410.37z"/>
            </g>
            <g>
                <path class="st4" d="M2967.67,554.12h-1898.9c-79.26,0-143.74-64.49-143.74-143.75s64.48-143.75,143.74-143.75h1898.9
                    c79.26,0,143.74,64.49,143.74,143.75S3046.93,554.12,2967.67,554.12z M1068.77,342.28c-37.55,0-68.09,30.55-68.09,68.08
                    s30.55,68.08,68.09,68.08h1898.9c37.55,0,68.09-30.55,68.09-68.08s-30.55-68.08-68.09-68.08H1068.77z"/>
            </g>
            <g>
                <path class="st0" d="M2942.4,516.29l-13.32,105.92l-107.13,847.47c-52.2,413.52-403.84,723.55-820.69,723.55
                    c-419.57,0-772.73-314.11-821.6-730.81l-98.5-840.21l-12.41-105.92H2942.4z"/>
            </g>
            <g>
                <path class="st1" d="M2929.09,622.2H1671.94c-191,0-339.23,166.66-316.94,356.36l45.44,386.71
                    c48.72,416.7,398.84,764.96,818.27,764.96c75.8,0,152.67-44.43,222.72-63.8c-128,80.65-279.31,126.79-440.15,126.79
                    c-419.57,0-772.73-314.11-821.6-730.81l-98.5-840.21l-12.41-105.92H2942.4L2929.09,622.2z"/>
            </g>
            <g class="st2">
                <path class="st3" d="M2942.4,516.29l-120.44,953.39c-52.2,413.52-403.84,723.55-820.69,723.55c-21.94,0-43.73-0.91-65.21-2.57
                    c387.5-30.71,705.39-329.4,754.87-720.98l120.44-953.39H2942.4z"/>
            </g>
            <g>
                <path class="st4" d="M2001.33,2231.11c-438.69,0-808.05-328.57-859.15-764.27l-115.94-988.39h1959.12l-125.81,996.01
                    C2805.06,1905.82,2436.11,2231.11,2001.33,2231.11z M1111.29,554.12l106.02,903.91c46.65,397.59,383.69,697.42,784.01,697.42
                    h0.01c396.75,0,733.43-296.83,783.17-690.47l115.05-910.86H1111.29z"/>
            </g>
            <g>
                <path class="st0" d="M2353.58,2354.67h-711.56c-13.25,0-23.99-10.74-23.99-23.99v-147.09c0-13.25,10.74-23.99,23.99-23.99h711.56
                    c13.25,0,23.99,10.74,23.99,23.99v147.09C2377.57,2343.93,2366.83,2354.67,2353.58,2354.67z"/>
            </g>
            <g>
                <path class="st1" d="M1893.54,2354.67h-177.94c-53.87,0-97.59-43.73-97.59-97.59c0-26.93,10.89-51.29,28.6-68.84
                    c17.7-17.7,42.06-28.6,69-28.6h177.94c-26.93,0-51.29,10.89-68.84,28.6c-17.7,17.55-28.6,41.91-28.6,68.84
                    C1796.1,2310.94,1839.68,2354.67,1893.54,2354.67z"/>
            </g>
            <g class="st2">
                <path class="st3" d="M2377.57,2257.08c0,26.93-10.89,51.29-28.6,69c-17.7,17.7-42.06,28.6-69,28.6h-136.18
                    c26.93,0,51.29-10.89,69-28.6c17.7-17.7,28.6-42.06,28.6-69c0-53.87-43.73-97.44-97.59-97.44h136.18
                    C2333.85,2159.63,2377.57,2203.21,2377.57,2257.08z"/>
            </g>
            <g class="st2">
                <rect x="1973.46" y="2173.1" class="st3" width="92.99" height="181.57"/>
            </g>
            <g>
                <path class="st4" d="M2280.03,2392.51h-564.46c-74.64,0-135.36-60.74-135.36-135.37c0-74.63,60.72-135.37,135.36-135.37h564.46
                    c74.64,0,135.36,60.74,135.36,135.37C2415.39,2331.77,2354.67,2392.51,2280.03,2392.51z M1715.57,2197.43
                    c-32.93,0-59.72,26.78-59.72,59.71c0,32.93,26.79,59.71,59.72,59.71h564.46c32.93,0,59.72-26.78,59.72-59.71
                    c0-32.93-26.79-59.71-59.72-59.71H1715.57z"/>
            </g>
            <g class="st5">
                <path class="st3" d="M2492.56,1342.22c61.96,14.85,91.9,111.57,66.86,216.03c-25.04,104.46-95.56,177.1-157.53,162.25
                    c-61.96-14.85-47.76-100.99-22.72-205.45C2404.22,1410.59,2430.6,1327.37,2492.56,1342.22z"/>
            </g>
            <g class="st5">
                <path class="st3" d="M2312.4,1918.02c-35.02,26.42-84.83,19.45-111.26-15.57c-26.42-35.02-14.21-77.89,20.81-104.31
                    c35.02-26.42,79.59-26.4,106.02,8.63C2354.39,1841.79,2347.42,1891.6,2312.4,1918.02z"/>
            </g>
        </g>
        <g>
            <rect x="1828.7" y="2354.67" class="st0" width="353.77" height="746.45"/>
        </g>
        <g>
            <polygon class="st1" points="2186.88,2445.45 1845.48,2576.59 1845.48,2354.67 2182.47,2354.67 		"/>
        </g>
        <g class="st2">
            <path class="st3" d="M2160.62,2455.54c-63.77,195.02-63.77,390.04,0,585.05V2455.54z"/>
        </g>
        <g>
            <path class="st4" d="M2182.47,3138.95H1828.7c-20.89,0-37.82-16.95-37.82-37.83v-746.44c0-20.88,16.93-37.83,37.82-37.83h353.77
                c20.89,0,37.82,16.95,37.82,37.83v746.44C2220.29,3122,2203.36,3138.95,2182.47,3138.95z M1866.52,3063.29h278.12v-670.78h-278.12
                V3063.29z"/>
        </g>
        <g>
            <path class="st0" d="M2285.9,3298.7h-587.04c-67.34,0-121.93-54.59-121.93-121.93l0,0c0-67.34,54.59-121.93,121.93-121.93h587.04
                c67.34,0,121.93,54.59,121.93,121.93l0,0C2407.84,3244.11,2353.25,3298.7,2285.9,3298.7z"/>
        </g>
        <g>
            <path class="st1" d="M1867.06,3298.67h-168.25c-67.33,0-121.95-54.62-121.95-121.95c0-33.74,13.62-64.15,35.71-86.24
                c22.09-22.09,52.65-35.71,86.25-35.71h168.25c-33.59,0-64.15,13.62-86.25,35.71c-22.09,22.09-35.71,52.5-35.71,86.24
                C1745.11,3244.05,1799.73,3298.67,1867.06,3298.67z"/>
        </g>
        <g class="st2">
            <path class="st3" d="M2407.84,3176.72c0,33.74-13.62,64.16-35.71,86.25c-22.09,22.09-52.66,35.71-86.25,35.71h-114.69
                c33.59,0,64.15-13.62,86.25-35.71c22.09-22.09,35.71-52.5,35.71-86.25c0-67.33-54.62-121.95-121.95-121.95h114.69
                C2353.21,3054.77,2407.84,3109.39,2407.84,3176.72z"/>
        </g>
        <g>
            <path class="st4" d="M2285.91,3336.54h-587.04c-88.09,0-159.76-71.68-159.76-159.77S1610.77,3017,1698.86,3017h587.04
                c88.09,0,159.75,71.68,159.75,159.77S2374,3336.54,2285.91,3336.54z M1698.86,3092.67c-46.38,0-84.11,37.73-84.11,84.1
                c0,46.37,37.73,84.1,84.11,84.1h587.04c46.37,0,84.1-37.73,84.1-84.1c0-46.37-37.73-84.1-84.1-84.1H1698.86z"/>
        </g>
        <g>
            <path class="st0" d="M2801.23,3623.38c0,19.67-8.02,37.52-20.88,50.39c-12.86,12.86-30.72,20.88-50.39,20.88H1196.02
                c-39.34,0-71.11-31.93-71.11-71.27c0-89.73,36.31-170.83,95.02-229.53c35.71-35.86,79.74-63.25,128.91-79.28
                c31.62-10.29,65.52-15.89,100.62-15.89h1027.07C2655.83,3298.67,2801.23,3444.08,2801.23,3623.38z"/>
        </g>
        <g>
            <path class="st1" d="M1893.54,3694.64h-697.53c-39.34,0-71.11-31.93-71.11-71.27c0-89.73,36.31-170.83,95.02-229.53
                c35.71-35.86,79.74-63.25,128.91-79.28C1366.09,3576.02,1588.36,3669.22,1893.54,3694.64z"/>
        </g>
        <g class="st2">
            <path class="st3" d="M2801.23,3623.38c0,19.67-8.02,37.52-20.88,50.39c-7.87,7.87-17.55,13.92-28.45,17.4
                c-1.97-159.48-118.78-291.27-271.75-316.38c-24.06,83.67-219.09,82.31-237.4-4.24h-842.48c-89.72,0-170.83,36.31-229.53,95.17
                c-3.78,3.78-7.57,7.87-11.2,11.8c15.59-31.17,36.01-59.31,60.37-83.67c58.71-58.86,139.96-95.17,229.53-95.17h1027.07
                C2655.83,3298.67,2801.23,3444.08,2801.23,3623.38z"/>
        </g>
        <g>
            <path class="st4" d="M2729.99,3732.42h-1533.9c-60.14,0-109.06-48.93-109.06-109.07c0-199.89,162.62-362.51,362.5-362.51h1027.02
                c199.89,0,362.5,162.63,362.5,362.51C2839.05,3683.49,2790.14,3732.42,2729.99,3732.42z M1449.53,3336.5
                c-158.17,0-286.86,128.68-286.86,286.85c0,18.42,15,33.41,33.42,33.41h1533.9c18.42,0,33.42-14.99,33.42-33.41
                c0-158.16-128.68-286.85-286.86-286.85H1449.53z"/>
        </g>
    </g>
    </svg>
    `,
    
    cup_2:`<?xml version="1.0" encoding="utf-8"?>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 4000 4000" style="enable-background:new 0 0 4000 4000;" xml:space="preserve">
    <style type="text/css">
    .st0{fill:#CBCCD0;}
    .st1{opacity:0.3;}
    .st2{fill:#6B184E;}
    .st3{opacity:0.55;}
    .st4{fill:#FFFFFF;}
    .st5{opacity:0.42;}
    </style>
    <g>
    <g>
    <rect x="1859.07" y="2243.06" class="st0" width="375.97" height="793.29"/>
    </g>
    <g class="st1">
    <polygon class="st2" points="2239.72,2339.54 1876.9,2478.91 1876.9,2243.06 2235.04,2243.06 		"/>
    </g>
    <g class="st3">
    <path class="st4" d="M2186.4,2350.26c-67.77,207.26-67.77,414.51,0,621.77V2350.26z"/>
    </g>
    <g>
    <path class="st2" d="M2235.05,3091h-375.98c-30.19,0-54.65-24.48-54.65-54.65v-793.28c0-30.17,24.46-54.65,54.65-54.65h375.98
    c30.19,0,54.65,24.48,54.65,54.65v793.28C2289.7,3066.52,2265.24,3091,2235.05,3091z M1913.72,2981.69h266.67v-683.97h-266.67
    V2981.69z"/>
    </g>
    <g>
    <path class="st0" d="M2456.76,3246.34h-847.49c-9.82,0-17.78-7.96-17.78-17.78v-223.6c0-9.82,7.96-17.78,17.78-17.78h847.49
    c9.82,0,17.78,7.96,17.78,17.78v223.6C2474.55,3238.38,2466.59,3246.34,2456.76,3246.34z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M1899.84,3246.31h-178.81c-71.56,0-129.61-58.05-129.61-129.61c0-35.86,14.47-68.18,37.95-91.66
    c23.48-23.48,55.96-37.95,91.66-37.95h178.81c-35.7,0-68.18,14.47-91.66,37.95c-23.48,23.48-37.95,55.8-37.95,91.66
    C1770.23,3188.26,1828.28,3246.31,1899.84,3246.31z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M2474.55,3116.7c0,35.86-14.47,68.18-37.95,91.66c-23.48,23.48-55.96,37.95-91.66,37.95h-121.89
    c35.7,0,68.18-14.47,91.66-37.95c23.48-23.48,37.95-55.8,37.95-91.66c0-71.56-58.05-129.61-129.61-129.61h121.89
    C2416.5,2987.09,2474.55,3045.14,2474.55,3116.7z"/>
    </g>
    <g>
    <path class="st2" d="M2344.96,3301.01h-623.89c-101.59,0-184.23-82.66-184.23-184.25s82.64-184.25,184.23-184.25h623.89
    c101.59,0,184.25,82.66,184.25,184.25S2446.55,3301.01,2344.96,3301.01z M1721.07,3041.83c-41.31,0-74.92,33.63-74.92,74.94
    c0,41.31,33.61,74.94,74.92,74.94h623.89c41.33,0,74.94-33.63,74.94-74.94c0-41.31-33.61-74.94-74.94-74.94H1721.07z"/>
    </g>
    <g>
    <path class="st0" d="M2892.63,3591.39c0,20.9-8.52,39.88-22.19,53.55c-13.67,13.67-32.64,22.19-53.55,22.19H1186.68
    c-41.81,0-75.58-33.93-75.58-75.74c0-95.36,38.59-181.55,100.98-243.94c37.95-38.11,84.74-67.22,137-84.26
    c33.61-10.93,69.63-16.88,106.93-16.88h1091.53C2738.1,3246.31,2892.63,3400.84,2892.63,3591.39z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M1927.98,3667.13h-741.3c-41.81,0-75.58-33.93-75.58-75.74c0-95.36,38.59-181.55,100.98-243.94
    c37.95-38.11,84.74-67.22,137-84.26C1367.42,3541.06,1603.64,3640.11,1927.98,3667.13z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M2892.63,3591.39c0,20.9-8.52,39.88-22.19,53.55c-8.36,8.36-18.65,14.79-30.23,18.49
    c-2.09-169.48-126.23-309.54-288.8-336.24c-25.57,88.92-232.84,87.48-252.3-4.5h-895.35c-95.36,0-181.55,38.59-243.94,101.14
    c-4.02,4.02-8.04,8.36-11.9,12.54c16.56-33.13,38.27-63.03,64.16-88.92c62.39-62.55,148.74-101.14,243.94-101.14h1091.53
    C2738.1,3246.31,2892.63,3400.84,2892.63,3591.39z"/>
    </g>
    <g>
    <path class="st2" d="M2816.93,3721.74H1186.77c-71.89,0-130.37-58.5-130.37-130.37c0-220.4,179.32-399.7,399.72-399.7h1091.47
    c220.4,0,399.7,179.3,399.7,399.7C2947.28,3663.24,2888.8,3721.74,2816.93,3721.74z M1456.11,3300.97
    c-160.14,0-290.41,130.27-290.41,290.39c0,11.6,9.45,21.07,21.06,21.07h1630.16c11.6,0,21.05-9.47,21.05-21.07
    c0-160.12-130.27-290.39-290.39-290.39H1456.11z"/>
    </g>
    <g>
    <g>
    <path class="st0" d="M3396.43,1603.87l-22.83,2.57c-157.43,18.97-254.07,54.03-306.81,115.3c26.53,22.35,45.35,54.19,50.65,91.34
    c2.25,16.24,1.93,32.32-0.96,47.44c0,0,0,0,0,0.16c-11.1,60.78-59.82,109.99-123.98,119.31
    c-80.72,11.58-155.34-44.22-167.07-124.94c-2.89-21.23-1.45-41.81,4.18-61.1h-0.16c28.62-164.66,128.32-256.16,238.95-308.42
    h0.16c104.68-49.53,219.17-63.84,292.5-71.88c1.61,0,3.05-0.32,4.34-0.48l4.82-0.48c152.92-22.67,259.21-165.3,237.18-318.39
    c-22.03-153.73-164.98-260.66-318.55-238.47c-7.72,1.13-15.44,2.41-22.99,4.18l0.32,1.61c0.48,3.54,0.64,6.91,0.96,10.45
    c0,0,0,0,0,0.16c0,0,0,0.16,0,0.32c1.29,18.81-0.8,36.98-6.27,54.19c-16.4,52.42-61.43,93.43-119.64,101.79
    c-80.56,11.58-155.17-44.22-166.75-124.94c-7.72-53.23,13.99-103.72,52.74-135.07v-0.16c18.17-15.12,37.47-28.78,57.73-40.84
    l0.16-0.16c53.71-32.16,113.53-53.55,176.24-62.55c259.05-37.31,499.93,142.95,537.08,402.01
    C3835.74,1325.69,3655.48,1566.57,3396.43,1603.87z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M3465.89,1380.04c98.73-55.16,158.55-167.23,141.51-285.75c-19.62-136.36-134.43-236.06-267.41-241.04
    c0-6.59-0.48-13.19-1.45-19.78l-0.32-1.61c7.56-1.77,15.28-3.05,22.99-4.18c153.57-22.19,296.52,84.74,318.55,238.47
    C3700.66,1211.36,3606.11,1347.07,3465.89,1380.04z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M3117.43,1813.08c10.29,71.88-32.96,138.93-99.38,160.96c27.34-31.2,41.49-73.65,35.05-118.03
    c-1.87-13.12-5.43-25.58-10.43-37.2c-18.25-42.47-2.7-92.58,38.85-112.83c0.33-0.16,0.67-0.33,1.01-0.49
    c-5.63,5.15-10.93,10.61-15.76,16.24C3093.31,1744.09,3112.13,1775.93,3117.43,1813.08z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M3267.14,872.06c0,0-2.41,22.83-6.27,54.67c-16.4,52.42-61.43,93.43-119.64,101.79
    c-80.56,11.58-155.17-44.22-166.75-124.94c-7.72-53.23,13.99-103.72,52.74-135.07v-0.16c18.17-15.12,37.47-28.78,57.73-40.84
    C2979.3,860.81,3161.33,1005.37,3267.14,872.06z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M3116.47,1860.52c0,0,0,0,0,0.16c-11.1,60.78-59.82,109.99-123.98,119.31
    c-80.72,11.58-155.34-44.22-167.07-124.94c-2.89-21.23-1.45-41.81,4.18-61.1h-0.16c28.62-164.66,128.32-256.16,238.95-308.42
    h0.16C2901.8,1646.33,2934.76,2004.27,3116.47,1860.52z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M3558.51,1549.36c128.16-101.47,200.52-266.45,175.6-439.63c-37.15-259.05-278.03-439.31-537.08-402.17
    c-57.08,8.36-111.76,26.69-161.61,54.19c65.12-51.62,143.11-85.06,225.93-96.96c259.05-37.31,499.93,142.95,537.08,402.01
    C3827.38,1267.15,3725.91,1456.58,3558.51,1549.36z"/>
    </g>
    <g>
    <path class="st2" d="M2970.93,2036.23c-43.34,0-85.33-13.91-120.63-40.31c-43.2-32.34-71.22-79.6-78.92-133.08
    c-3.84-26.79-2.4-53.44,4.31-79.28c64.8-367.92,438.57-408.84,579.35-424.25l10.43,53.87l-6.03-54.33l4.8-0.53
    c121.12-17.97,206.86-133.04,189.12-256.3c-16.63-115.64-118.06-196.91-232.58-194.35c-4.23,34.73-17.4,67.61-38.73,96.11
    c-32.33,43.2-79.6,71.2-133.08,78.89c-110.43,15.8-212.8-61.02-228.65-171.29c-9.86-68.5,16.56-137.95,69.07-182.47
    c0.98-0.96,1.99-1.85,3.02-2.7c74.58-61.73,164.92-101.66,261.23-115.5c139.77-20.14,278.97,15.51,392.21,100.24
    c113.22,84.76,186.65,208.37,206.73,348.07l0,0c41.51,288.72-159.61,557.4-448.34,598.92l-24.36,2.85
    c-111.34,13.34-188.34,34.87-236.8,66.61c14.66,23.48,24.41,49.96,28.43,77.93c7.69,53.48-5.92,106.75-38.3,149.94
    c-32.36,43.2-79.58,71.2-132.99,78.85C2990.43,2035.52,2980.64,2036.23,2970.93,2036.23z M2883.88,1799.54
    c-0.32,3.13-0.91,6.26-1.8,9.36c-3.54,12.38-4.38,25.3-2.49,38.36c3.54,24.59,16.4,46.29,36.22,61.17
    c19.82,14.84,44.19,21.03,68.83,17.51c24.53-3.52,46.22-16.4,61.08-36.22c14.87-19.82,21.12-44.26,17.58-68.82
    c-3.22-22.45-14.5-42.81-31.72-57.29c-11.19-9.39-18.15-22.88-19.32-37.43c-1.17-14.55,3.52-28.96,13.04-40.03
    c61.61-71.66,167.02-112.97,341.81-133.93l23.09-2.67c227.55-32.74,387.12-245.91,354.17-474.96l0,0
    c-15.92-110.8-74.19-208.87-164.03-276.12c-89.83-67.25-200.29-95.4-311.15-79.6c-75.17,10.82-145.71,41.63-204.24,89.21
    c-1.05,1-2.15,1.96-3.29,2.88c-25.44,20.57-37.82,52.27-33.13,84.83c7.28,50.67,54.46,86,104.9,78.71
    c24.57-3.56,46.29-16.4,61.13-36.22c14.82-19.82,21.05-44.26,17.51-68.85c-4.06-28.22,14.02-56.4,41.83-62.7
    c8.91-2.03,17.88-3.7,27.1-5.05c183.57-26.26,354.21,101.41,380.59,284.77c26.26,182.68-100.82,353.26-283.29,380.27l-6.78,0.82
    c-1.26,0.21-4.47,0.57-8.11,0.75C3166.08,1489.97,2930.06,1547.58,2883.88,1799.54z"/>
    </g>
    </g>
    <g>
    <g>
    <path class="st0" d="M684.84,1603.87l22.83,2.57c157.43,18.97,254.07,54.03,306.81,115.3c-26.53,22.35-45.35,54.19-50.65,91.34
    c-2.25,16.24-1.93,32.32,0.96,47.44c0,0,0,0,0,0.16c11.1,60.78,59.82,109.99,123.98,119.31
    c80.72,11.58,155.34-44.22,167.07-124.94c2.89-21.23,1.45-41.81-4.18-61.1h0.16c-28.62-164.66-128.32-256.16-238.95-308.42h-0.16
    c-104.68-49.53-219.17-63.84-292.5-71.88c-1.61,0-3.06-0.32-4.34-0.48l-4.82-0.48c-152.92-22.67-259.21-165.3-237.18-318.39
    c22.03-153.73,164.98-260.66,318.55-238.47c7.72,1.13,15.44,2.41,22.99,4.18l-0.32,1.61c-0.48,3.54-0.64,6.91-0.96,10.45
    c0,0,0,0,0,0.16c0,0,0,0.16,0,0.32c-1.29,18.81,0.8,36.98,6.27,54.19c16.4,52.42,61.43,93.43,119.64,101.79
    c80.56,11.58,155.17-44.22,166.75-124.94c7.72-53.23-13.99-103.72-52.74-135.07v-0.16c-18.17-15.12-37.47-28.78-57.73-40.84
    l-0.16-0.16c-53.71-32.16-113.53-53.55-176.24-62.55c-259.05-37.31-499.93,142.95-537.08,402.01
    C245.53,1325.69,425.79,1566.57,684.84,1603.87z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M615.37,1380.04c-98.73-55.16-158.55-167.23-141.51-285.75c19.62-136.36,134.43-236.06,267.41-241.04
    c0-6.59,0.48-13.19,1.45-19.78l0.32-1.61c-7.56-1.77-15.28-3.05-23-4.18c-153.57-22.19-296.52,84.74-318.55,238.47
    C380.6,1211.36,475.15,1347.07,615.37,1380.04z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M963.83,1813.08c-10.29,71.88,32.96,138.93,99.38,160.96c-27.34-31.2-41.49-73.65-35.05-118.03
    c1.87-13.12,5.43-25.58,10.43-37.2c18.25-42.47,2.7-92.58-38.85-112.83c-0.33-0.16-0.67-0.33-1.01-0.49
    c5.63,5.15,10.93,10.61,15.76,16.24C987.95,1744.09,969.14,1775.93,963.83,1813.08z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M814.13,872.06c0,0,2.41,22.83,6.27,54.67c16.4,52.42,61.43,93.43,119.64,101.79
    c80.56,11.58,155.17-44.22,166.75-124.94c7.72-53.23-13.99-103.72-52.74-135.07v-0.16c-18.17-15.12-37.47-28.78-57.73-40.84
    C1101.96,860.81,919.93,1005.37,814.13,872.06z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M964.8,1860.52c0,0,0,0,0,0.16c11.1,60.78,59.82,109.99,123.98,119.31
    c80.72,11.58,155.34-44.22,167.07-124.94c2.89-21.23,1.45-41.81-4.18-61.1h0.16c-28.62-164.66-128.32-256.16-238.95-308.42h-0.16
    C1179.47,1646.33,1146.5,2004.27,964.8,1860.52z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M522.75,1549.36c-128.16-101.47-200.52-266.45-175.6-439.63c37.15-259.05,278.03-439.31,537.08-402.17
    c57.08,8.36,111.76,26.69,161.61,54.19c-65.12-51.62-143.11-85.06-225.93-96.96c-259.05-37.31-499.93,142.95-537.08,402.01
    C253.89,1267.15,355.36,1456.58,522.75,1549.36z"/>
    </g>
    <g>
    <path class="st2" d="M1110.34,2036.23c-9.73,0-19.52-0.71-29.3-2.13c-53.39-7.65-100.61-35.65-132.97-78.85
    c-32.38-43.2-45.99-96.46-38.3-149.94c4.02-27.97,13.77-54.44,28.43-77.93c-48.48-31.74-125.5-53.27-237.03-66.65l-22.6-2.6
    c-290.26-41.74-491.38-310.42-449.87-599.14c20.09-139.7,93.51-263.31,206.73-348.07c113.22-84.72,252.53-120.27,392.21-100.24
    c96.3,13.84,186.65,53.77,261.23,115.5c1.05,0.85,2.06,1.78,3.04,2.7c52.5,44.51,78.9,113.97,69.05,182.47
    c-15.85,110.31-118.38,187.16-228.65,171.29c-53.48-7.69-100.75-35.69-133.08-78.89c-21.4-28.61-34.59-61.56-38.82-96.11
    c-113.95-4.73-215.86,78.71-232.5,194.35c-17.74,123.26,68,238.33,191.1,256.59l2.83,0.25c1.19,0.07,3.22,0.32,4.39,0.46
    c140.78,15.41,514.56,56.33,579.35,424.25c6.71,25.83,8.15,52.48,4.31,79.28c-7.69,53.48-35.71,100.73-78.92,133.08
    C1195.68,2022.32,1153.68,2036.23,1110.34,2036.23z M751.65,714.52c-89.97,0-177.24,28.93-250.71,83.94
    c-89.85,67.25-148.11,165.32-164.04,276.12l0,0c-32.95,229.04,126.62,442.18,355.68,475.17l21.33,2.42
    c175.03,20.99,280.44,62.3,342.05,133.97c9.52,11.07,14.22,25.48,13.04,40.03c-1.17,14.55-8.13,28.04-19.32,37.43
    c-17.22,14.48-28.5,34.84-31.72,57.29c-3.54,24.55,2.7,49,17.58,68.82c14.86,19.82,36.54,32.7,61.06,36.22
    c24.45,3.45,49.03-2.7,68.87-17.51c19.82-14.87,32.68-36.58,36.2-61.17c1.89-13.06,1.05-25.97-2.49-38.36
    c-0.89-3.13-1.49-6.26-1.81-9.43c-46.22-251.89-282.22-309.5-483.03-331.49c-0.14,0.11-3.29-0.25-6.55-0.75l-2.83-0.25
    c-184.44-27.29-311.52-197.87-285.26-380.55c26.38-183.36,197.04-311.42,380.47-284.77c9.32,1.35,18.29,3.02,27.22,5.05
    c27.81,6.26,46.13,32.88,42.04,61.13c-3.75,26.15,2.47,50.6,17.29,70.42c14.84,19.82,36.56,32.66,61.13,36.22
    c50.49,7.33,97.64-28.04,104.9-78.71c4.7-32.56-7.69-64.26-33.13-84.83c-1.14-0.93-2.26-1.89-3.31-2.92
    c-58.53-47.54-129.06-78.35-204.23-89.17C791.89,715.98,771.7,714.52,751.65,714.52z M282.8,1066.79h0.36H282.8z"/>
    </g>
    </g>
    <g>
    <g>
    <path class="st0" d="M3069.51,557.05H1051.45c-62.17,0-112.56-50.4-112.56-112.56l0,0c0-62.17,50.4-112.56,112.56-112.56h2018.07
    c62.17,0,112.56,50.4,112.56,112.56l0,0C3182.08,506.66,3131.68,557.05,3069.51,557.05z"/>
    </g>
    <g class="st3">
    <rect x="1705.37" y="350.69" class="st4" width="576.21" height="206.36"/>
    </g>
    <g class="st3">
    <rect x="2352.62" y="350.69" class="st4" width="108.52" height="206.36"/>
    </g>
    <g class="st1">
    <path class="st2" d="M1297.96,557.05h-246.51c-62.23,0-112.56-50.33-112.56-112.56c0-31.2,12.54-59.17,32.96-79.6
    c20.42-20.42,48.4-32.96,79.6-32.96h246.51c-31.04,0-59.18,12.54-79.6,32.96c-20.26,20.42-32.96,48.4-32.96,79.6
    C1185.39,506.72,1235.89,557.05,1297.96,557.05z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M3182.08,444.49c0,31.2-12.54,59.18-32.96,79.6c-20.42,20.42-48.4,32.96-79.6,32.96H2930.1
    c31.04,0,59.34-12.54,79.6-32.96c20.42-20.42,32.96-48.4,32.96-79.6c0-62.23-50.33-112.56-112.56-112.56h139.42
    C3131.75,331.93,3182.08,382.26,3182.08,444.49z"/>
    </g>
    <g>
    <path class="st2" d="M3069.51,611.72H1051.45c-92.21,0-167.22-75.01-167.22-167.24c0-92.19,75.01-167.2,167.22-167.2h2018.06
    c92.21,0,167.22,75.01,167.22,167.2C3236.73,536.71,3161.72,611.72,3069.51,611.72z M1051.45,386.59
    c-31.94,0-57.91,25.97-57.91,57.89c0,31.95,25.98,57.93,57.91,57.93h2018.06c31.94,0,57.91-25.97,57.91-57.93
    c0-31.92-25.98-57.89-57.91-57.89H1051.45z"/>
    </g>
    <g>
    <path class="st0" d="M3042.66,557.05l-14.15,112.56l-113.85,900.65c-55.48,439.47-429.18,768.96-872.19,768.96
    c-445.9,0-821.22-333.82-873.16-776.67l-104.68-892.93l-13.19-112.56H3042.66z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M3028.51,669.61H1692.47c-202.99,0-360.52,177.12-336.83,378.72l48.29,410.98
    c51.78,442.85,423.87,812.96,869.62,812.96c80.56,0,162.25-47.22,236.7-67.81c-136.04,85.71-296.84,134.75-467.77,134.75
    c-445.9,0-821.22-333.82-873.16-776.67l-104.68-892.93l-13.19-112.56h1991.22L3028.51,669.61z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M3042.66,557.05l-128,1013.22c-55.48,439.47-429.18,768.96-872.19,768.96c-23.32,0-46.47-0.96-69.31-2.73
    c411.81-32.64,749.66-350.07,802.24-766.22l128-1013.22H3042.66z"/>
    </g>
    <g>
    <path class="st2" d="M2042.53,2393.94c-473.55,0-872.25-354.69-927.42-825.02L990.01,502.41H3104.7l-135.75,1074.73
    C2910.14,2042.81,2511.86,2393.94,2042.53,2393.94z M1112.88,611.72l110.79,944.47c48.71,415.28,400.75,728.44,818.86,728.44
    c414.39,0,766.04-310.03,817.97-721.15l120.23-951.76H1112.88z"/>
    </g>
    <g class="st5">
    <path class="st4" d="M2564.59,1434.82c65.85,15.78,97.67,118.57,71.06,229.59s-101.56,188.22-167.41,172.43
    c-65.85-15.78-50.75-107.33-24.15-218.34C2470.7,1507.48,2498.74,1419.03,2564.59,1434.82z"/>
    </g>
    <g class="st5">
    <path class="st4" d="M2373.12,2046.75c-37.22,28.08-90.16,20.67-118.24-16.55c-28.08-37.22-15.1-82.78,22.12-110.86
    c37.22-28.08,84.59-28.05,112.67,9.17C2417.75,1965.73,2410.34,2018.67,2373.12,2046.75z"/>
    </g>
    </g>
    </g>
    </svg>
    `,
    
    cup_3:`<?xml version="1.0" encoding="utf-8"?>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 4000 4000" style="enable-background:new 0 0 4000 4000;" xml:space="preserve">
    <style type="text/css">
    .st0{fill:#F89F1D;}
    .st1{opacity:0.3;}
    .st2{fill:#6B184E;}
    .st3{opacity:0.55;}
    .st4{fill:#FFFFFF;}
    .st5{opacity:0.42;}
    </style>
    <g>
    <g>
    <rect x="1819.59" y="2131.84" class="st0" width="372.85" height="786.72"/>
    </g>
    <g class="st1">
    <polygon class="st2" points="2197.09,2525.12 1837.27,2663.33 1837.27,2429.44 2192.44,2429.44 		"/>
    </g>
    <g class="st3">
    <path class="st4" d="M2144.2,2238.16c-67.21,205.54-67.21,411.08,0,616.62V2238.16z"/>
    </g>
    <g>
    <path class="st2" d="M2192.43,2972.76h-372.85c-29.94,0-54.2-24.28-54.2-54.2v-786.7c0-29.92,24.26-54.2,54.2-54.2h372.85
    c29.94,0,54.2,24.28,54.2,54.2v786.7C2246.64,2948.48,2222.38,2972.76,2192.43,2972.76z M1873.79,2864.35h264.45v-678.3h-264.45
    V2864.35z"/>
    </g>
    <g>
    <path class="st0" d="M2412.18,3126.81h-840.17c-9.82,0-17.78-7.96-17.78-17.78v-221.46c0-9.82,7.96-17.78,17.78-17.78h840.17
    c9.82,0,17.78,7.96,17.78,17.78v221.46C2429.97,3118.84,2422,3126.81,2412.18,3126.81z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M1860.02,3126.77h-177.33c-70.96,0-128.53-57.57-128.53-128.53c0-35.56,14.35-67.61,37.63-90.9
    c23.28-23.28,55.49-37.64,90.9-37.64h177.33c-35.4,0-67.61,14.35-90.9,37.64c-23.28,23.28-37.63,55.34-37.63,90.9
    C1731.49,3069.21,1789.06,3126.77,1860.02,3126.77z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M2429.97,2998.24c0,35.56-14.35,67.62-37.63,90.9c-23.28,23.28-55.5,37.64-90.9,37.64h-120.88
    c35.4,0,67.62-14.35,90.9-37.64c23.28-23.28,37.63-55.34,37.63-90.9c0-70.96-57.57-128.53-128.53-128.53h120.88
    C2372.4,2869.71,2429.97,2927.28,2429.97,2998.24z"/>
    </g>
    <g>
    <path class="st2" d="M2301.45,3181.02h-618.72c-100.75,0-182.72-81.97-182.72-182.72c0-100.75,81.97-182.72,182.72-182.72h618.72
    c100.75,0,182.72,81.97,182.72,182.72C2484.17,3099.05,2402.2,3181.02,2301.45,3181.02z M1682.74,2923.99
    c-40.99,0-74.32,33.35-74.32,74.32c0,40.97,33.33,74.32,74.32,74.32h618.72c40.99,0,74.32-33.35,74.32-74.32
    c0-40.97-33.33-74.32-74.32-74.32H1682.74z"/>
    </g>
    <g>
    <path class="st0" d="M2844.59,3469c0,20.73-8.45,39.55-22.01,53.1c-13.55,13.55-32.37,22.01-53.1,22.01h-1616.7
    c-41.46,0-74.95-33.65-74.95-75.11c0-94.57,38.27-180.04,100.15-241.92c37.63-37.79,84.04-66.66,135.87-83.56
    c33.33-10.84,69.05-16.74,106.05-16.74h1082.48C2691.34,3126.77,2844.59,3280.02,2844.59,3469z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M1887.93,3544.11h-735.16c-41.46,0-74.95-33.65-74.95-75.11c0-94.57,38.27-180.04,100.15-241.92
    c37.63-37.79,84.04-66.66,135.87-83.56C1332.02,3419.08,1566.28,3517.32,1887.93,3544.11z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M2844.59,3469c0,20.73-8.45,39.55-22.01,53.1c-8.29,8.29-18.5,14.67-29.98,18.34
    c-2.07-168.08-125.18-306.98-286.41-333.45c-25.36,88.19-230.91,86.75-250.21-4.46h-887.93c-94.57,0-180.04,38.27-241.91,100.31
    c-3.99,3.99-7.97,8.29-11.8,12.44c16.43-32.85,37.95-62.51,63.63-88.19c61.87-62.03,147.51-100.31,241.91-100.31h1082.48
    C2691.34,3126.77,2844.59,3280.02,2844.59,3469z"/>
    </g>
    <g>
    <path class="st2" d="M2769.51,3598.26H1152.84c-71.28,0-129.28-58.01-129.28-129.29c0-218.57,177.83-396.39,396.4-396.39h1082.41
    c218.57,0,396.4,177.81,396.4,396.39C2898.79,3540.25,2840.79,3598.26,2769.51,3598.26z M1419.97,3180.99
    c-158.81,0-288,129.19-288,287.98c0,11.5,9.37,20.89,20.87,20.89h1616.67c11.5,0,20.87-9.39,20.87-20.89
    c0-158.79-129.19-287.98-288-287.98H1419.97z"/>
    </g>
    <g>
    <g>
    <path class="st0" d="M3344.21,1795.55l-22.65,2.55c-156.12,18.82-251.96,53.58-304.27,114.34
    c26.31,22.17,44.97,53.74,50.23,90.58c2.23,16.11,1.91,32.05-0.96,47.04c0,0,0,0,0,0.16c-11,60.28-59.32,109.08-122.95,118.33
    c-80.05,11.48-154.05-43.85-165.69-123.91c-2.87-21.05-1.44-41.46,4.15-60.6h-0.16c28.39-163.3,127.26-254.04,236.97-305.86h0.16
    c103.82-49.12,217.36-63.31,290.08-71.28c1.59,0,3.03-0.32,4.31-0.48l4.78-0.48c151.66-22.49,257.07-163.93,235.22-315.75
    c-21.85-152.45-163.62-258.5-315.91-236.49c-7.66,1.12-15.31,2.39-22.8,4.15l0.32,1.6c0.48,3.51,0.64,6.86,0.96,10.36
    c0,0,0,0,0,0.16c0,0,0,0.16,0,0.32c1.28,18.66-0.8,36.68-6.22,53.74c-16.27,51.99-60.92,92.65-118.65,100.94
    c-79.9,11.48-153.89-43.85-165.37-123.91c-7.65-52.78,13.87-102.86,52.31-133.96v-0.16c18.02-14.99,37.16-28.55,57.25-40.51
    l0.16-0.16c53.26-31.89,112.59-53.1,174.78-62.03c256.91-37,495.79,141.77,532.63,398.67
    C3779.88,1519.67,3601.11,1758.55,3344.21,1795.55z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M3413.1,1573.57c97.91-54.7,157.24-165.85,140.33-283.38c-19.46-135.23-133.32-234.1-265.2-239.05
    c0-6.54-0.48-13.08-1.44-19.61l-0.32-1.59c7.49-1.75,15.15-3.03,22.8-4.15c152.29-22.01,294.06,84.04,315.91,236.49
    C3645.92,1406.28,3552.15,1540.88,3413.1,1573.57z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M3067.52,2003.02c10.21,71.28-32.69,137.78-98.55,159.63c27.11-30.94,41.14-73.04,34.76-117.05
    c-1.86-13.01-5.39-25.37-10.34-36.89c-18.1-42.11-2.68-91.81,38.52-111.89c0.33-0.16,0.66-0.32,1-0.48
    c-5.58,5.1-10.84,10.52-15.63,16.11C3043.6,1934.61,3062.26,1966.18,3067.52,2003.02z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M3215.99,1069.8c0,0-2.39,22.65-6.22,54.22c-16.27,51.99-60.92,92.65-118.65,100.94
    c-79.9,11.48-153.89-43.85-165.37-123.91c-7.65-52.78,13.87-102.86,52.31-133.96v-0.16c18.02-14.99,37.16-28.55,57.25-40.51
    C2930.54,1058.64,3111.06,1202,3215.99,1069.8z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M3066.57,2050.06c0,0,0,0,0,0.16c-11,60.28-59.32,109.08-122.95,118.33
    c-80.05,11.48-154.05-43.85-165.69-123.91c-2.87-21.05-1.44-41.46,4.15-60.6h-0.16c28.39-163.3,127.26-254.04,236.97-305.86h0.16
    C2853.68,1837.65,2886.37,2192.63,3066.57,2050.06z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M3504.95,1741.49c127.1-100.63,198.86-264.24,174.14-435.99c-36.84-256.91-275.72-435.67-532.63-398.83
    c-56.61,8.29-110.83,26.47-160.27,53.74c64.59-51.19,141.93-84.36,224.06-96.16c256.91-37,495.79,141.77,532.63,398.67
    C3771.58,1461.62,3670.96,1649.47,3504.95,1741.49z"/>
    </g>
    <g>
    <path class="st2" d="M2922.62,2224.31c-98.01,0-183.94-72.16-198.28-171.92c-3.81-26.61-2.38-52.97,4.25-78.55
    c64.24-365.05,434.96-405.56,574.57-420.8c0.11,0,4.66-0.53,4.75-0.53l4.76-0.49c119.73-17.79,204.76-131.94,187.17-254.14
    c-8.52-59.35-39.73-111.9-87.88-147.93c-41.69-31.19-91.82-46.51-142.81-44.82c-4.2,34.55-17.26,67.08-38.38,95.28
    c-32.06,42.84-78.94,70.61-131.98,78.23c-53.05,7.76-105.72-5.79-148.53-37.9c-42.82-32.08-70.61-78.94-78.23-131.94
    c-9.79-68.07,16.53-137.13,68.81-181.27c0.86-0.81,1.76-1.62,2.68-2.36c74-61.26,163.59-100.89,259.06-114.58
    c138.61-19.94,276.66,15.39,388.96,99.41c112.29,84.05,185.1,206.64,205.02,345.18c19.92,138.54-15.4,276.69-99.46,388.98
    c-84.05,112.29-206.63,185.08-345.17,204.99l-24.1,2.86c-110.49,13.23-186.83,34.55-234.87,66.02
    c14.5,23.29,24.17,49.58,28.16,77.31c15.74,109.36-60.45,211.16-169.84,226.9C2941.66,2223.63,2932.1,2224.31,2922.62,2224.31z
    M2835.9,1989.54c-0.32,3.14-0.9,6.28-1.78,9.35c-3.51,12.28-4.34,25.05-2.47,38.07c3.49,24.35,16.25,45.87,35.9,60.59
    c19.67,14.75,43.95,20.86,68.3,17.4c50.21-7.23,85.2-53.99,77.97-104.2c-3.19-22.3-14.34-42.45-31.41-56.74
    c-11.1-9.32-18.01-22.69-19.2-37.12c-1.18-14.43,3.48-28.76,12.92-39.73c61.07-71.07,165.6-112.04,338.97-132.82l22.85-2.68
    c108.44-15.6,205.67-73.36,272.39-162.46c66.69-89.1,94.73-198.7,78.92-308.56c-15.79-109.89-73.57-207.14-162.68-273.83
    c-89.08-66.69-198.63-94.61-308.57-78.94c-74.63,10.73-144.68,41.39-202.82,88.71c-0.95,0.92-1.96,1.8-3,2.61
    c-25.23,20.4-37.51,51.87-32.85,84.16c3.49,24.38,16.25,45.91,35.91,60.62c19.64,14.75,43.79,20.93,68.1,17.4
    c24.4-3.53,45.93-16.27,60.64-35.92c14.71-19.66,20.87-43.9,17.36-68.25c-4.01-27.91,13.78-55.79,41.25-62.14
    c9-2.08,18.05-3.78,27.33-5.08c88.06-12.49,175.64,9.81,246.96,63.2c71.33,53.39,117.6,131.23,130.25,219.24
    c26.04,181.13-99.97,350.3-280.93,377.12l-7.13,0.81c-0.9,0.18-4.08,0.56-7.66,0.74
    C3115.77,1682.53,2881.71,1739.63,2835.9,1989.54z"/>
    </g>
    </g>
    <g>
    <g>
    <path class="st0" d="M655.09,1795.55l22.65,2.55c156.12,18.82,251.96,53.58,304.27,114.34c-26.31,22.17-44.97,53.74-50.23,90.58
    c-2.23,16.11-1.91,32.05,0.96,47.04c0,0,0,0,0,0.16c11,60.28,59.32,109.08,122.95,118.33c80.05,11.48,154.05-43.85,165.69-123.91
    c2.87-21.05,1.44-41.46-4.15-60.6h0.16c-28.39-163.3-127.26-254.04-236.97-305.86h-0.16c-103.81-49.12-217.36-63.31-290.08-71.28
    c-1.59,0-3.03-0.32-4.31-0.48l-4.78-0.48c-151.66-22.49-257.07-163.93-235.22-315.75c21.85-152.45,163.62-258.5,315.91-236.49
    c7.66,1.12,15.31,2.39,22.8,4.15l-0.32,1.6c-0.48,3.51-0.64,6.86-0.96,10.36c0,0,0,0,0,0.16c0,0,0,0.16,0,0.32
    c-1.28,18.66,0.8,36.68,6.22,53.74c16.27,51.99,60.92,92.65,118.65,100.94c79.89,11.48,153.89-43.85,165.37-123.91
    c7.65-52.78-13.87-102.86-52.31-133.96v-0.16c-18.02-14.99-37.16-28.55-57.25-40.51l-0.16-0.16
    c-53.26-31.89-112.59-53.1-174.78-62.03c-256.91-37-495.79,141.77-532.63,398.67C219.42,1519.67,398.18,1758.55,655.09,1795.55z"
    />
    </g>
    <g class="st1">
    <path class="st2" d="M586.2,1573.57c-97.91-54.7-157.24-165.85-140.33-283.38c19.46-135.23,133.32-234.1,265.2-239.05
    c0-6.54,0.48-13.08,1.44-19.61l0.32-1.59c-7.49-1.75-15.15-3.03-22.8-4.15c-152.29-22.01-294.06,84.04-315.91,236.49
    C353.37,1406.28,447.14,1540.88,586.2,1573.57z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M931.77,2003.02c-10.21,71.28,32.69,137.78,98.55,159.63c-27.11-30.94-41.14-73.04-34.76-117.05
    c1.86-13.01,5.39-25.37,10.34-36.89c18.1-42.11,2.68-91.81-38.52-111.89c-0.33-0.16-0.66-0.32-1-0.48
    c5.58,5.1,10.84,10.52,15.63,16.11C955.69,1934.61,937.03,1966.18,931.77,2003.02z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M783.3,1069.8c0,0,2.39,22.65,6.22,54.22c16.27,51.99,60.92,92.65,118.65,100.94
    c79.89,11.48,153.89-43.85,165.37-123.91c7.65-52.78-13.87-102.86-52.31-133.96v-0.16c-18.02-14.99-37.16-28.55-57.25-40.51
    C1068.75,1058.64,888.23,1202,783.3,1069.8z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M932.73,2050.06c0,0,0,0,0,0.16c11,60.28,59.32,109.08,122.95,118.33
    c80.05,11.48,154.05-43.85,165.69-123.91c2.87-21.05,1.44-41.46-4.15-60.6h0.16c-28.39-163.3-127.26-254.04-236.97-305.86h-0.16
    C1145.62,1837.65,1112.93,2192.63,932.73,2050.06z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M494.34,1741.49c-127.1-100.63-198.86-264.24-174.14-435.99c36.84-256.91,275.72-435.67,532.63-398.83
    c56.61,8.29,110.83,26.47,160.27,53.74c-64.58-51.19-141.93-84.36-224.05-96.16c-256.91-37-495.79,141.77-532.63,398.67
    C227.71,1461.62,328.34,1649.47,494.34,1741.49z"/>
    </g>
    <g>
    <path class="st2" d="M1076.67,2224.31c-9.46,0-19.02-0.67-28.65-2.08c-109.39-15.74-185.6-117.54-169.87-226.94
    c4.01-27.74,13.67-53.99,28.18-77.28c-48.06-31.48-124.44-52.79-235.07-66.06l-22.48-2.61
    c-139.97-20.11-262.56-92.91-346.61-205.2c-84.04-112.29-119.36-250.4-99.44-388.98c19.92-138.54,92.74-261.13,205.02-345.18
    c112.29-84.02,250.51-119.31,388.96-99.41c95.45,13.69,185.03,53.32,259.05,114.58c0.94,0.74,1.83,1.55,2.72,2.4
    c52.28,44.11,78.59,113.17,68.79,181.24c-7.62,53-35.41,99.86-78.23,131.94c-42.84,32.08-95.63,45.59-148.56,37.9
    c-53.02-7.62-99.88-35.39-131.94-78.23c-21.23-28.34-34.28-61.01-38.5-95.28c-50.97-1.98-101.06,13.66-142.69,44.82
    c-48.15,36.03-79.36,88.57-87.88,147.93c-17.59,122.2,67.43,236.36,189.53,254.46l2.4,0.18c1.16,0.07,3.58,0.39,4.75,0.53
    c139.62,15.24,510.33,55.79,574.57,420.8c6.63,25.58,8.06,51.98,4.25,78.51C1260.59,2152.14,1174.65,2224.31,1076.67,2224.31z
    M721.35,913.55c-89.22,0-175.77,28.69-248.64,83.24c-89.1,66.69-146.88,163.95-162.68,273.83
    c-15.81,109.89,12.23,219.45,78.92,308.56c66.69,89.1,163.95,146.87,273.81,162.68l21.23,2.43
    c173.54,20.82,278.1,61.79,339.17,132.86c9.44,10.97,14.1,25.3,12.92,39.73c-1.18,14.43-8.1,27.81-19.2,37.12
    c-17.06,14.29-28.23,34.44-31.42,56.74c-7.22,50.21,27.77,96.97,78,104.2c50.18,7.23,96.97-27.81,104.19-78.02
    c1.87-12.99,1.04-25.76-2.47-38.04c-0.88-3.11-1.48-6.25-1.8-9.42c-45.87-249.84-279.9-306.93-479.03-328.67
    c0.07,0-3.25-0.25-6.44-0.74l-2.47-0.21c-183.32-27.14-309.33-196.31-283.29-377.44c12.65-88.01,58.91-165.85,130.25-219.24
    c71.33-53.43,159.11-75.94,247.07-63.17c9.17,1.27,18.24,3,27.24,5.05c27.22,6.32,45.2,32.29,41.52,59.99
    c-3.79,26.5,2.36,50.74,17.08,70.4c14.72,19.66,36.24,32.39,60.61,35.92c24.31,3.49,48.52-2.65,68.14-17.4
    c19.66-14.71,32.41-36.24,35.9-60.62c4.66-32.29-7.62-63.77-32.85-84.16c-1.04-0.85-2.05-1.73-3.02-2.61
    c-58.15-47.32-128.2-77.99-202.8-88.71C761.26,914.99,741.23,913.55,721.35,913.55z"/>
    </g>
    </g>
    <g>
    <g>
    <path class="st0" d="M3116.19,757.4H922.47c-8.53,0-15.45-6.92-15.45-15.45V549.59c0-8.53,6.92-15.45,15.45-15.45h2193.71
    c8.53,0,15.45,6.92,15.45,15.45v192.36C3131.63,750.49,3124.72,757.4,3116.19,757.4z"/>
    </g>
    <g class="st3">
    <rect x="1667.17" y="552.75" class="st4" width="571.43" height="204.65"/>
    </g>
    <g class="st3">
    <rect x="2309.05" y="552.75" class="st4" width="107.62" height="204.65"/>
    </g>
    <g class="st1">
    <path class="st2" d="M1263.12,757.4h-244.47c-61.71,0-111.63-49.91-111.63-111.63c0-30.94,12.44-58.69,32.69-78.94
    c20.25-20.25,48-32.69,78.94-32.69h244.47c-30.78,0-58.68,12.44-78.94,32.69c-20.09,20.25-32.69,48-32.69,78.94
    C1151.5,707.49,1201.57,757.4,1263.12,757.4z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M3131.63,645.77c0,30.94-12.44,58.68-32.69,78.94c-20.25,20.25-48,32.69-78.94,32.69h-138.26
    c30.78,0,58.84-12.44,78.94-32.69c20.25-20.25,32.69-48,32.69-78.94c0-61.71-49.91-111.63-111.63-111.63H3020
    C3081.72,534.14,3131.63,584.06,3131.63,645.77z"/>
    </g>
    <g>
    <path class="st2" d="M3020,811.6H1018.66c-91.45,0-165.83-74.39-165.83-165.82c0-91.47,74.39-165.85,165.83-165.85H3020
    c91.45,0,165.83,74.39,165.83,165.85C3185.83,737.21,3111.45,811.6,3020,811.6z M1018.66,588.34
    c-31.67,0-57.43,25.76-57.43,57.45c0,31.65,25.76,57.41,57.43,57.41H3020c31.67,0,57.43-25.76,57.43-57.41
    c0-31.69-25.76-57.45-57.43-57.45H1018.66z"/>
    </g>
    <g>
    <path class="st0" d="M2993.37,757.4l-14.03,111.63l-112.9,893.19c-55.02,435.83-425.63,762.58-864.96,762.58
    c-442.21,0-814.41-331.06-865.92-770.24l-103.81-885.54l-13.08-111.63H2993.37z"/>
    </g>
    <g class="st1">
    <path class="st2" d="M2979.34,869.03H1654.37c-201.31,0-357.53,175.65-334.04,375.58l47.89,407.57
    c51.35,439.18,420.36,806.23,862.41,806.23c79.89,0,160.91-46.83,234.74-67.24c-134.91,85-294.38,133.63-463.9,133.63
    c-442.21,0-814.41-331.06-865.92-770.24l-103.81-885.54l-13.08-111.63h1974.71L2979.34,869.03z"/>
    </g>
    <g class="st3">
    <path class="st4" d="M2993.37,757.4l-126.94,1004.82c-55.02,435.83-425.63,762.58-864.96,762.58c-23.12,0-46.09-0.96-68.73-2.71
    c408.4-32.37,743.45-347.17,795.6-759.87L2855.27,757.4H2993.37z"/>
    </g>
    <g>
    <path class="st2" d="M2001.53,2579.05c-469.63,0-865.02-351.71-919.74-818.14L957.74,703.2H3054.9l-134.62,1065.86
    C2861.95,2230.83,2466.97,2579.05,2001.53,2579.05z M1079.59,811.6l109.87,936.68c48.31,411.81,397.43,722.37,812.07,722.37
    c410.96,0,759.69-307.46,811.19-715.14l119.24-943.91H1079.59z"/>
    </g>
    <g class="st5">
    <path class="st4" d="M2519.26,1627.89c65.31,15.65,96.86,117.59,70.47,227.68c-26.39,110.1-100.72,186.66-166.02,171
    c-65.31-15.65-50.33-106.44-23.95-216.53C2426.15,1699.95,2453.96,1612.24,2519.26,1627.89z"/>
    </g>
    <g class="st5">
    <path class="st4" d="M2329.38,2234.75c-36.91,27.85-89.41,20.5-117.26-16.41c-27.85-36.91-14.98-82.09,21.93-109.94
    s83.89-27.82,111.74,9.09C2373.64,2154.41,2366.29,2206.91,2329.38,2234.75z"/>
    </g>
    </g>
    </g>
    </svg>
    `,
}